/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
(globalThis["webpackChunk_spurit_tropicfeel_kw_new_theme"] = globalThis["webpackChunk_spurit_tropicfeel_kw_new_theme"] || []).push([["sections.page"],{

/***/ "./src/scripts/sections/page.js":
/*!**************************************!*\
  !*** ./src/scripts/sections/page.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_page_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/page.scss */ \"./src/styles/sections/page.scss\");\n/* harmony import */ var _styles_snippets_rich_content_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../styles/snippets/rich-content.scss */ \"./src/styles/snippets/rich-content.scss\");\n\n\n\n//# sourceURL=webpack://@spurit/tropicfeel-kw-new-theme/./src/scripts/sections/page.js?");

/***/ }),

/***/ "./src/styles/sections/page.scss":
/*!***************************************!*\
  !*** ./src/styles/sections/page.scss ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://@spurit/tropicfeel-kw-new-theme/./src/styles/sections/page.scss?");

/***/ })

}]);